import React from 'react';
import { Text, } from 'react-native';
import { FontInfo, } from '../~Utilities/Constants';
import { Data } from '../~Utilities/Data';

export interface ITextPC
{
  oData    : Data | undefined;
}

/*   ====================================================================   */

export default class TextPC extends React.Component<ITextPC>
 {
  UpdateData()
  {
  let sText = this.GetPCData();

  if (this.state.sText != sText)
      this.setState({sText: sText});
  }

  /*   -------------------------------------------------------------------   */

  GetPCData()
  {
  if (this.props.oData == undefined)
    return("");
  else
    {
    if (this.props.oData.nc < 0)
      return(this.props.oData.pc.toFixed(2) + "%");
    else
      return("+" + this.props.oData.pc.toFixed(2) + "%");    }
  }

  /*   -------------------------------------------------------------------   */
  
  GetNCPure()
  {
  if (this.props.oData == undefined)
    return('green');
  else
    {
    if (this.props.oData.nc < 0)
      return('red');
    else
      return('green');
    }
  }

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.UpdateData = this.UpdateData.bind(this);
  this.GetPCData  = this.GetPCData.bind(this);
  this.GetNCPure  = this.GetNCPure.bind(this);

  this.state      = {sText:this.GetPCData()};
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  }

  /*   -------------------------------------------------------------------   */

  state = {
      sText: ""
   }

   /*   -------------------------------------------------------------------   */

  render() 
  {
  return(
    <Text style={[FontInfo.appStyles.txt_normal, {marginLeft:-2,
          paddingHorizontal:0, 
          margin:0, opacity:1, color:this.GetNCPure()}]}> {this.state.sText} </Text>
      );
  }
}